import Linkify from 'linkify-react'
import DOMPurify from 'dompurify'
import parse from "html-react-parser";
const { toHTML } = require("slack-markdown");

const ChatMessage = ({ msg }) => {
  const safeMsg = DOMPurify.sanitize(toHTML(msg))
  return (
    <div id="chatMessage" className="text-dark/70 child-highlight w-fit whitespace-pre-line">
      <Linkify tagName="p" className="pr-4 max-w-[50vw] break-words">{parse(safeMsg)}</Linkify>
    </div>
  )
}

export default ChatMessage
